// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3FapV","row":"Node_row__2hfHy","label":"Node_label__3sg2U","footer":"Node_footer__3JAfb"};